import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import cls from './Row.module.css';

export default class Cell extends PureComponent {
  static propTypes = {
    tagName: PropTypes.string,
    item: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    rowIdx: PropTypes.number,
    grow: PropTypes.bool,
    cellProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    rowProps: PropTypes.object,
    renderer: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    context: PropTypes.object,
  };

  static defaultProps = {
    tagName: 'td',
    item: null,
    cellProps: {},
    rowProps: {},
    context: {},
  };

  buildRenderer = () => {
    const { renderer } = this.props;

    if (typeof renderer === 'string') {
      return item => item[renderer];
    }

    if (typeof renderer !== 'function') {
      return () => null;
    }

    return renderer;
  };

  buildCellProps = () => {
    const { item, rowIdx, cellProps } = this.props;

    if (typeof cellProps === 'function') {
      return cellProps(item, rowIdx);
    }

    return cellProps;
  };

  onCatchEvent = event => {
    event.stopPropagation();
    event.preventDefault();
  };

  onClick = event => {
    const cellProps = this.buildCellProps();

    if (typeof cellProps?.onClick !== 'function') {
      return;
    }

    const { item, rowIdx } = this.props;

    this.onCatchEvent(event);
    cellProps.onClick(item, rowIdx, event);
  };

  onDoubleClick = event => {
    const cellProps = this.buildCellProps();

    if (typeof cellProps?.onDoubleClick !== 'function') {
      return;
    }

    const { item, rowIdx } = this.props;

    this.onCatchEvent(event);
    cellProps.onClick(item, rowIdx, event);
  };

  render() {
    const { item, tagName, context, grow, rowProps } = this.props;

    const cellProps = this.buildCellProps();
    const renderer = this.buildRenderer();

    return React.createElement(
      tagName,
      {
        ...cellProps,
        className: cx(cls.cell, { [cls.grow]: grow }, cellProps?.className),
        onClick: this.onClick,
        onDoubleClick: this.onDoubleClick,
      },
      renderer(item, { context, rowProps })
    );
  }
}
